const SET_CHANNEL_LIST = '@channel/set-channel-list';
const SET_CHANNEL_DETAIL = '@channel/set-channel-detail';

export {SET_CHANNEL_LIST, SET_CHANNEL_DETAIL};